import React from "react";
import { SVGS } from "../../assets/svgs";
import styles from "./wrapper.module.css";

const {} = SVGS;

export const IconWrapper = ({ children, pad }) => {
  return <div style={{padding:pad}} className={styles.contents2}>{children}</div>;
};
